<template>
    <div class='common common-form-inline'>

        <!-- <div v-if="aprvStCd == 2" class="apro-box">审核意见：<div>{{ aproCheckInfo }}</div>
        </div> -->
        <a-form-model ref="vertifyForm" :model="pageData" :rules="vertifyRules" :label-col="labelCol"
            :wrapper-col="wrapperCol">
            <div class="common-title">审批记录</div>
            <div class="page-main no-shadow">
                <a-table size="middle" :columns="columns" :row-key="record => record.id" :data-source="dataList"
                    :bordered="true" :pagination="false" :locale="{ emptyText: '暂无数据' }">
                    <template slot="createTime" slot-scope="text">{{
                        text | dateFormat("YYYY-mm-dd")
                        }}</template>
                </a-table>
            </div>
            <div class="common-title">企业基本信息</div>
            <div class="page-main no-shadow">
                <a-row :gutter="0">
                    <a-col :span="11">
                        <a-form-model-item label="企业名称" prop="cstNm">
                            <a-input v-model="pageData.cstNm" disabled />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-model-item label="社会信用代码" prop="orgCode">
                            <a-input v-model="pageData.orgCode" disabled />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="0">
                    <a-col :span="11">
                        <a-form-model-item label="企业联系电话" prop="phone">
                            <a-input v-model="pageData.phone" :disabled="readonly" />
                        </a-form-model-item>

                    </a-col>
                    <a-col :span="11">
                        <a-form-model-item label="所属行业" prop="industryType">
                            <a-select v-model="pageData.industryType" :disabled="readonly">
                                <a-select-option v-for="d in industryList" :key="d.dctVal" :value="d.dctVal"
                                    :label="d.dctValNm" :title="d.dctValNm">
                                    {{ d.dctValNm }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="0">
                    <a-col :span="11">
                        <a-form-model-item label="企业规模" prop="companyScale">
                            <a-popover v-if="!readonly">
                                <template slot="content">
                                    <p style="font-size:12px;line-height:18px;">从业人员300人以下的为中小微型企业。<br />
                                        其中，从业人员100人及以上的为中型企业；<br />
                                        从业人员10人及以上的为小型企业；<br />
                                        从业人员10人及以下的为微型企业。</p>
                                </template>
                                <span class="hoverText">企业规模</span>
                            </a-popover>
                            <a-select v-model="pageData.companyScale" :disabled="readonly">
                                <a-select-option v-for="d in EntpSzList" :key="d.dctVal" :value="d.dctVal"
                                    :label="d.dctValNm" :title="d.dctValNm">
                                    {{ d.dctValNm }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-model-item label="企业分类" prop="companyCategory">
                            <a-select v-model="pageData.companyCategory" :disabled="readonly">
                                <a-select-option v-for="d in companyCategoryList" :key="d.dctVal" :value="d.dctVal"
                                    :label="d.dctValNm" :title="d.dctValNm">
                                    {{ d.dctValNm }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="0">
                    <a-col :span="11">
                        <a-form-model-item label="注册地址" prop="address">
                            <div style="position:relative;">
                                <div class="spaceBetween">
                                    <a-cascader style="width:100%" v-model="provCity"
                                        :fieldNames="{ label: 'areaName', value: 'areaCode', children: 'children' }"
                                        :options="RgstPrvcList" :load-data="loadData" placeholder="请选择" change-on-select
                                        :disabled="readonly" @change="onChangeProv" />
                                </div>
                                <a-input v-model="pageData.address" :maxLength="50" placeholder="请输入详细地址"
                                    :disabled="readonly"></a-input>
                                <span v-if="!readonly" class="input-text">{{ (pageData.address &&
                                    pageData.address.length) || 0 }}/50</span>
                            </div>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-model-item label="通讯地址" prop="communicationAddress">
                            <div style="position:relative;">
                                <div class="spaceBetween">
                                    <a-cascader style="width:100%" v-model="provcommunicationCity"
                                        :fieldNames="{ label: 'areaName', value: 'areaCode', children: 'children' }"
                                        :options="RgstPrvcListCommun" :load-data="loadDataCommun" placeholder="请选择"
                                        change-on-select :disabled="readonly" @change="onChangeProvCommun" />
                                </div>
                                <a-input v-model="pageData.communicationAddress" :maxLength="50" placeholder="请输入详细地址"
                                    :disabled="readonly"></a-input>
                                <span v-if="!readonly" class="input-text">{{ (pageData.communicationAddress &&
                                    pageData.communicationAddress.length) || 0 }}/50</span>
                                <div class="check-address" v-if="!readonly">
                                    <a-checkbox @change="setProvcommunicationCity">
                                        同注册地址
                                    </a-checkbox>
                                </div>
                            </div>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="0">
                    <a-col :span="11">
                        <a-form-model-item label="营业执照照片" required>
                            <imgUpload :disabled="readonly" @remove="removeOk" :file="getFile('1')"
                                :paramObj="paramObj1" @uploadOk="uploadOk" name="file"></imgUpload>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-model-item label="营业期限" prop="businessHoursSd">
                            <start-end-date ref="startEndDate1" :disabled="readonly" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </div>

            <!-- <a-divider :dashed="true" style="margin:0 0 15px 0;position: relative;top:-15px;"/> -->
            <div class="common-title">法定代表人信息</div>
            <div class="page-main no-shadow">
                <a-row :gutter="0">
                    <a-col :span="11">
                        <a-form-model-item label="法人姓名" prop="lglpsnNm">
                            <a-input v-model="pageData.lglpsnNm" :disabled="readonly" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-model-item label="法人证件类型" prop="legalPersonCertificateType">
                            <a-select v-model="pageData.legalPersonCertificateType" :disabled="readonly">
                                <a-select-option v-for="d in LegalPersonCertTypeList" :key="d.dctVal" :value="d.dctVal"
                                    :label="d.dctValNm" :title="d.dctValNm">
                                    {{ d.dctValNm }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="0">
                    <a-col :span="11">
                        <a-form-model-item label="法人证件号码" prop="lglpsnCrdtNo">
                            <a-input v-model="pageData.lglpsnCrdtNo" :disabled="readonly" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-model-item label="有效期限" prop="legalPersonCertificateSd">
                            <start-end-date ref="startEndDate2" :disabled="readonly" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="0">
                    <a-col :span="11">
                        <a-form-model-item label="法人证件照片" :rules="{ required: true }">
                            <div class="spaceLeft" style="width:500px">
                                <div>
                                    <imgUpload @remove="removeOk" :disabled="readonly" :file="getFile('2')"
                                        :paramObj="paramObj2" @uploadOk="uploadOk" text="上传证件正面" name="file">
                                    </imgUpload>
                                </div>
                                <div>
                                    <imgUpload @remove="removeOk" :disabled="readonly" :file="getFile('3')"
                                        :paramObj="paramObj3" @uploadOk="uploadOk" text="上传证件背面" name="file">
                                    </imgUpload>
                                </div>
                            </div>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </div>
            <!-- <a-divider :dashed="true" style="margin:0 0 15px 0;position: relative;top:-15px;"/> -->
            <div class="common-title">基本账户信息</div>
            <div class="page-main no-shadow">
                <a-row :gutter="0">
                    <a-col :span="11">
                        <a-form-model-item label="基本账户号" prop="basicAccNo">
                            <a-input v-model="pageData.basicAccNo" :disabled="readonly" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-model-item label="基本开户行" prop="basicAccName">
                            <a-input v-model="pageData.basicAccName" :disabled="readonly" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-model-item label="基本户开户许可证" :rules="{ required: true }">
                            <imgUpload @remove="removeOk" :file="getFile('9')" :paramObj="paramObj9"
                                @uploadOk="uploadOk" :disabled="readonly" name="file"></imgUpload>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-model-item label="大额行号" prop="largeBankNo">
                            <a-input v-model="pageData.largeBankNo" :disabled="readonly" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </div>
            <!-- <a-divider :dashed="true" style="margin:0 0 15px 0;position: relative;top:-15px;"/> -->
            <div class="common-title">管理员信息</div>
            <div class="page-main no-shadow">
                <a-row :gutter="0">
                    <a-col :span="11">
                        <a-form-model-item label="管理员姓名" prop="mnpltPsnNm">
                            <a-input v-model="pageData.mnpltPsnNm" :disabled="readonly" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-model-item label="管理员身份证" prop="mnpltPsnCrdtNo">
                            <a-input v-model="pageData.mnpltPsnCrdtNo" :disabled="readonly" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-model-item label="有效期限" prop="operatorIdNumberSd">
                            <start-end-date ref="startEndDate3" :disabled="readonly" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-model-item label="管理员电话" prop="ctcPsnTel">
                            <a-input v-model="pageData.ctcPsnTel" :disabled="readonly" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="0">
                    <a-col :span="11">
                        <a-form-model-item label="管理员身份证照片" :rules="{ required: true }">
                            <div class="spaceLeft" style="width:600px">
                                <div>
                                    <imgUpload @remove="removeOk" :file="getFile('4')" :disabled="readonly"
                                        :paramObj="paramObj4" @uploadOk="uploadOk" text="正面" name="file"></imgUpload>
                                </div>
                                <div>
                                    <imgUpload @remove="removeOk" :file="getFile('5')" :disabled="readonly"
                                        :paramObj="paramObj5" @uploadOk="uploadOk" text="反面" name="file"></imgUpload>
                                </div>
                                <div>
                                    <imgUpload @remove="removeOk" :file="getFile('10')" :disabled="readonly"
                                        :paramObj="paramObj10" @uploadOk="uploadOk" text="管理员手持身份证照片" name="file">
                                    </imgUpload>
                                </div>
                                <a @click="openExample" style="position: relative;top:30px;">示例</a>
                            </div>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="0">
                    <a-col :span="11">
                        <a-form-model-item label="授权委托书" :rules="{ required: true }">
                            <div class="spaceLeft" style="width:600px">
                                <div>
                                    <imgUpload @remove="removeOk" :file="getFile('7')" :disabled="readonly"
                                        :paramObj="paramObj7" @uploadOk="uploadOk" name="file"></imgUpload>
                                </div>
                                <!-- <a href="javascript:void(0)" style="position: relative;top:30px;"
                                        @click="fileDownload()"
                                        >授权委托书(企业认证)模板下载</a> -->
                                <a @click="fileDownload()" href="javascript:void(0)" download="授权委托书_企业认证.doc"
                                    style="position: relative;top:30px;">授权委托书(企业认证)模板下载</a>
                            </div>
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <!-- <a-divider v-if="!readonly" :dashed="true" style="margin:0 0 15px 0;position: relative;top:-15px;"/> -->
                <!-- <a-row v-if="!readonly" :gutter="0">
                            <a-col :span="11">
                                <a-form-model-item label="设置交易密码" prop="confirmPswd">
                                    <a-input v-model="pageData.confirmPswd" :disabled="isDetail" type="password"/>
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="11">
                                <a-form-model-item label="确认密码" prop="txnPswd">
                                    <a-input v-model="pageData.txnPswd" :disabled="isDetail" type="password"/>
                                </a-form-model-item>
                            </a-col>
                        </a-row> -->
                <!-- <a-divider :dashed="true" style="margin:0 0 15px 0;"/> -->
                <!-- <a-row :gutter="0">
                            <a-col :span="11">
                                <a-form-model-item label="税控身份认证">
                                    <div class="text-color-orange" style="width:500px;">请您保存信息后，到税控电脑上下载并安装税控安全认证工具</div>
                                    <a-button @click="safeDownload" type="primary">下载税控安全认证工具</a-button>
                                </a-form-model-item>
                            </a-col>
                        </a-row> -->
            </div>
        </a-form-model>
        <!-- <a-divider :dashed="true" style="margin:0 0 15px 0;"/> -->
        <div style="margin-left:12%;">
            <p>认证信息填写完成后请将下述纸质资料邮寄至我司，我司在收到资料后将尽快审核您的认证申请。</p>
            <div class="flexStart">
                <div>
                    <p>邮寄资料清单：</p><span class="text-color-orange">(均需加盖企业公章)</span>
                </div>
                <div style="margin-left:15px;">
                    <ul class="ver-li">
                        <li>1. 营业执照复印件</li>
                        <li>2. 开户许可证复印件</li>
                        <li>3. 法人身份证正反面复印件</li>
                        <li>4. 管理员身份证正反面复印件</li>
                        <li>5. 管理员手持身份证照片打印件</li>
                        <li>6. 授权委托书原件</li>
                    </ul>
                    <p>地址：河南省南阳市卧龙区七里园乡美盛白河湾商业楼44号楼106号</p>
                    <p>收件人：彭松　　电话：15290365751</p>
                </div>
            </div>
        </div>
        <div class="model-footer-btns spaceCenter">
            <a-button @click="goback" class="btn-blue-line btn-big">返回</a-button>
            <a-button v-if="!readonly" type="primary" @click="save" class="btn-big">保存</a-button>
            <a-button v-if="!readonly" type="primary" @click="submit" class="btn-big">提交</a-button>
        </div>
        <imgView ref="imgViewAprov" src="/static/images/example.png" />
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { getUserInfo, getApproveInfoByAprvId, queryApproveInfo, temporary, save, getUserChangeApplyId, getUserInfoApproveList } from "@/api/security.js"
import { fileQueryAPI, RcvbSingleFileSave } from "@/api/file.js"
import imgUpload from "@/components/ui/img-upload/img-upload"
import { getDic, getAreaList } from '@/api/dic.js'
export default {
    props: ["isDetail"],
    name: "vertify",
    components: { imgUpload },
    data() {
        return {
            labelCol: { span: 8 },
            wrapperCol: { span: 13 },
            aprvInfo: {},
            aproCheckInfo: "",
            aprvStCd: "",
            readonly: false,
            pageData: {
                country: "CHN"
            },
            provCity: [],
            provcommunicationCity: [],
            companyCategoryList: [],
            vertifyRules: {
                cstNm: {
                    required: true,
                    message: "请填写企业名称",
                    trigger: "blur",
                    whitespace: true
                },
                orgCode: {
                    required: true,
                    message: "请填写社会信用代码",
                    trigger: "blur",
                    whitespace: true
                },
                phone: {
                    required: true,
                    trigger: "blur",
                    whitespace: true,
                    validator: (rule, value, cbfn) => {
                        if (!value) {
                            cbfn('请填写企业联系电话');
                        } else if (!this.utils.regExpObj.MOBILE_FIXED.test(value)) {
                            cbfn('请输入正确的手机号码或固定电话');
                        }
                        cbfn();
                    }
                },
                industryType: {
                    required: true,
                    message: "请填写所属行业",
                    trigger: "blur",
                    whitespace: true
                },
                companyScale: {
                    required: true,
                    message: "请填写企业规模",
                    trigger: "change"
                },
                companyCategory: {
                    required: true,
                    message: "请选择企业分类",
                    trigger: "change"
                },
                address: {
                    required: true,
                    trigger: "change",
                    whitespace: true,
                    validator: (rule, value, cbfn) => {
                        if (!this.pageData.address || !this.provCity[0] || !this.provCity[1] || !this.provCity[2]) {
                            cbfn('请填写注册地址');
                        }
                        cbfn();
                    }
                },
                communicationAddress: {
                    required: true,
                    trigger: "change",
                    whitespace: true,
                    validator: (rule, value, cbfn) => {
                        if (!this.pageData.communicationAddress || !this.provcommunicationCity[0] || !this.provcommunicationCity[1] || !this.provcommunicationCity[2]) {
                            cbfn('请填写通讯地址');
                        }
                        cbfn();
                    }
                },
                businessHoursSd: {
                    required: true,
                    trigger: "change",
                    whitespace: true,
                    validator: (rule, value, cbfn) => {
                        let valObj = this.$refs.startEndDate1.getVal();
                        if (!valObj.startValue && !valObj.endValue) {
                            cbfn('请选择营业期限');
                        }
                        cbfn();
                    }
                },
                legalPersonCertificateSd: {
                    required: true,
                    trigger: "change",
                    whitespace: true,
                    validator: (rule, value, cbfn) => {
                        let valObj = this.$refs.startEndDate2.getVal();
                        if (!valObj.startValue && !valObj.endValue) {
                            cbfn('请选择有效期限');
                        }
                        cbfn();
                    }
                },
                operatorIdNumberSd: {
                    required: true,
                    trigger: "change",
                    whitespace: true,
                    validator: (rule, value, cbfn) => {
                        let valObj = this.$refs.startEndDate3.getVal();
                        if (!valObj.startValue && !valObj.endValue) {
                            cbfn('请选择有效期限');
                        }
                        cbfn();
                    }
                },
                largeBankNo: {
                    required: true,
                    trigger: "blur",
                    whitespace: true,
                    validator: (rule, value, cbfn) => {
                        if (!this.pageData.largeBankNo) {
                            cbfn('请填写大额行号');
                        }
                        else if (this.pageData.largeBankNo.length != 12) {
                            cbfn('大额行号需为12位数字');
                        }
                        cbfn();
                    }
                },
                fileList: {
                    required: true,
                    message: "请上传图片",
                    trigger: "change"
                },
                lglpsnNm: {
                    required: true,
                    message: "请填写法人姓名",
                    trigger: "blur"
                },
                legalPersonCertificateType: {
                    required: true,
                    message: "请填写法人证件类型",
                    trigger: "change"
                },
                lglpsnCrdtNo: {
                    required: true,
                    trigger: "blur",
                    validator: (rule, value, cbfn) => {
                        if (!value) {
                            cbfn('请填写法人证件号码');
                        } else if (!this.utils.regExpObj.IDCARD_PATTERN.test(value) && this.pageData.legalPersonCertificateType == '0') {
                            cbfn('输入身份证格式不正确');
                        }
                        else if (!this.utils.regExpObj.PASSPORT.test(value) && this.pageData.legalPersonCertificateType == '2') {
                            cbfn('输入护照格式不正确');
                        }
                        cbfn();
                    }
                },
                basicAccNo: {
                    required: true,
                    message: "请填写基本账号",
                    trigger: "blur"
                },
                basicAccName: {
                    required: true,
                    message: "请填写基本开户行",
                    trigger: "blur"
                },
                mnpltPsnNm: {
                    required: true,
                    message: "请填写管理员姓名",
                    trigger: "blur"
                },
                mnpltPsnCrdtNo: {
                    required: true,
                    trigger: "blur",
                    validator: (rule, value, cbfn) => {
                        if (!value) {
                            cbfn('请填写管理员身份证');
                        }
                        else if (!this.utils.regExpObj.IDCARD_PATTERN.test(value)) {
                            cbfn('身份证格式不正确');
                        }
                        cbfn();
                    }
                },
                ctcPsnTel: {
                    required: true,
                    trigger: "blur",
                    validator: (rule, value, cbfn) => {
                        if (!value) {
                            cbfn('请填写管理员电话');
                        }
                        else if (!this.utils.regExpObj.MOBILE_PATTERN.test(value)) {
                            cbfn('手机号码格式不正确');
                        }
                        else {
                            cbfn();
                        }

                    }
                },
                // confirmPswd:{
                //     required: true,
                //     trigger: "blur",
                //     validator:(rule,value,cbfn) => {
                //         if (!value) {
                //             cbfn('请填写交易密码');
                //         }
                //         else if(!this.utils.regExpObj.PASSWORD_PATTERN.test(value)){
                //             cbfn('字母/数字/特殊字符中至少两种组成，8-20位');
                //         }else{
                //             cbfn();
                //         }
                //     }
                // },
                // txnPswd:{
                //     required: true,
                //     trigger: "blur",
                //     validator:(rule,value,cbfn) => {
                //         if (!value) {
                //             cbfn('请填写确认密码');
                //         }
                //         else if(this.pageData.confirmPswd != value){
                //             cbfn('两次密码输入不一致');
                //         }
                //         else{
                //             cbfn();
                //         }
                //     }
                // }
            },
            industryList: [],
            LegalPersonCertTypeList: [],
            EntpSzList: [],
            RgstCtyList: [],
            RgstPrvcList: [],
            RgstPrvcListCommun: [],
            CityList: [],
            fileList: [],
            paramObj1: {
                app: "portal-pc",
                module: "approve",
                user: "",
                tblBlId: "",
                suprFileId: "1",
                mdlId: "approve"
            },
            paramObj2: {
                app: "portal-pc",
                module: "approve",
                user: "",
                tblBlId: "",
                suprFileId: "2",
                mdlId: "approve"
            },
            paramObj3: {
                app: "portal-pc",
                module: "approve",
                user: "",
                tblBlId: "",
                suprFileId: "3",
                mdlId: "approve"
            },
            paramObj9: {
                app: "portal-pc",
                module: "approve",
                user: "",
                tblBlId: "",
                suprFileId: "9",
                mdlId: "approve"
            },
            paramObj10: {
                app: "portal-pc",
                module: "approve",
                user: "",
                tblBlId: "",
                suprFileId: "10",
                mdlId: "approve"
            },
            paramObj7: {
                app: "portal-pc",
                module: "approve",
                user: "",
                tblBlId: "",
                suprFileId: "7",
                mdlId: "approve"
            },
            paramObj4: {
                app: "portal-pc",
                module: "approve",
                user: "",
                tblBlId: "",
                suprFileId: "4",
                mdlId: "approve"
            },
            paramObj5: {
                app: "portal-pc",
                module: "approve",
                user: "",
                tblBlId: "",
                suprFileId: "5",
                mdlId: "approve"
            },
            SECURITY_FILE_DOWNLOAD_URI: './static/templates/授权委托书_模板.doc',
            SECURITY_FILE_DOWNLOAD_URI1: 'templat_05',
            SECURITY_FILE_DOWNLOAD_URI2: '/static/templates/授权委托书_管理员变更.doc',
            DOWNLOAD_PREFIX: "/gb-bigtree-file/download/fileDownload/install",
            safeDownloadUrl: "",
            columns: [
                {
                    title: "步骤",
                    dataIndex: "taskName"
                },
                {
                    title: "审批结果",
                    dataIndex: "action"
                },
                {
                    title: "审批意见",
                    dataIndex: "comment",
                    scopedSlots: { customRender: "comment" }
                },
                {
                    title: "审批时间",
                    dataIndex: "createTime",
                    scopedSlots: { customRender: "createTime" }
                }
            ],
            dataList: []
        };
    },
    computed: {
        ...mapGetters({
            userObj: "home/getUserObj",
            getUserHeader: "home/getUserHeader"
        })
    },
    methods: {
        ...mapActions({
            getDicAsync: "app/getDicAsync"
        }),
        setFileParam(tblBlId, user) {
            this.paramObj1.tblBlId = tblBlId;
            this.paramObj1.user = user;
            this.paramObj2.tblBlId = tblBlId;
            this.paramObj2.user = user;
            this.paramObj3.tblBlId = tblBlId;
            this.paramObj3.user = user;
            this.paramObj4.tblBlId = tblBlId;
            this.paramObj4.user = user;
            this.paramObj5.tblBlId = tblBlId;
            this.paramObj5.user = user;
            this.paramObj7.tblBlId = tblBlId;
            this.paramObj7.user = user;
            this.paramObj9.tblBlId = tblBlId;
            this.paramObj9.user = user;
            this.paramObj10.tblBlId = tblBlId;
            this.paramObj10.user = user;
        },
        getUserInfo() {
            getUserInfo().then(res => {
                this.aprvInfo = res.data;
                this.aprvStCd = res.data.aprvSt;
                const aprvActiveCode = ['0', '1', '3']; //认证或认证通过
                this.readonly = aprvActiveCode.includes(this.aprvStCd);
                this.setFileParam(this.aprvInfo.aprvId, this.getUserHeader.loginName)
                getApproveInfoByAprvId({ aprvId: res.data.aprvId }).then(resData => {
                    this.aproCheckInfo = resData.data.apvOpn || "";
                })
                this.queryApproveInfo();
            }).catch(err => {
            })
        },
        queryApproveInfo() {
            queryApproveInfo(null, true).then(res => {
                this.pageData = res.data.aprvInfo;
                for (let key in this.pageData) {
                    if (this.pageData[key] == "-1") {
                        this.pageData[key] = undefined;
                    }
                }
                // this.$set(this.pageData,"txnPswd","");
                // this.$set(this.pageData,"confirmPswd","");
                // this.$set(this.pageData,"businessHoursSd",this.pageData.startValue);
                // this.$set(this.pageData,"endValue",this.pageData.endValue);
                this.$refs.startEndDate1.setVal(this.pageData.businessHoursSd, this.pageData.businessHoursEd);
                this.$refs.startEndDate2.setVal(this.pageData.legalPersonCertificateSd, this.pageData.legalPersonCertificateEd);
                this.$refs.startEndDate3.setVal(this.pageData.operatorIdNumberSd, this.pageData.operatorIdNumberEd);
                this.initProCity();
                this.initProCityCommun();
                this.fileList = res.data.fileList;
                this.safeDownloadUrl = res.data.safeDownloadUrl; // 获取税控安全认证工具地址
                this.provinceChange();
            }).catch(err => {
                this.$store.commit("home/setLoadMainStatus", false);
            })
        },
        getFile(type) {
            return this.fileList.find(i => i.suprFileId == type && !i.delet) || null;
        },
        // 省份选择回调
        onChangeProv(data) {
            this.pageData.province = data[0] || "";
            this.pageData.city = data[1] || "";
            this.pageData.area = data[2] || "";
        },
        // 通讯地址省份选择回调
        onChangeProvCommun(data) {
            this.pageData.communicationProvince = data[0] || "";
            this.pageData.communicationCity = data[1] || "";
            this.pageData.communicationArea = data[2] || ""

        },
        // 设置通讯地址同注册地址
        setProvcommunicationCity(data) {
            if (data.target.checked) {
                this.provcommunicationCity = [this.pageData.province, this.pageData.city, this.pageData.area];
                this.pageData.communicationAddress = this.pageData.address;
                this.onChangeProvCommun(this.provcommunicationCity);
                this.initProCityCommun();
            }
        },
        // 获取省份级联
        loadData(selectedOptions) {
            const targetOption = selectedOptions[selectedOptions.length - 1];
            targetOption.loading = true;
            let param = '';
            if (selectedOptions.length == 1) { //省份
                param = {
                    classify: '2',
                    areaCode: targetOption.areaCode
                };
            }
            else if (selectedOptions.length == 2) {
                param = {
                    classify: '3',
                    areaCode: targetOption.areaCode
                };
            }

            getAreaList(param).then(resp => {
                let res = resp.data;
                res.forEach((i, index) => {
                    res[index].isLeaf = selectedOptions.length == 2;
                })
                targetOption.children = res;
                targetOption.loading = false;
                this.RgstPrvcList = [...this.RgstPrvcList];
            })
        },
        // 获取通讯省份级联
        loadDataCommun(selectedOptions) {
            const targetOption = selectedOptions[selectedOptions.length - 1];
            targetOption.loading = true;
            let param = '';
            if (selectedOptions.length == 1) { //省份
                param = {
                    classify: '2',
                    areaCode: targetOption.areaCode
                };
            }
            else if (selectedOptions.length == 2) { //市
                param = {
                    classify: '3',
                    areaCode: targetOption.areaCode
                };
            }

            getAreaList(param).then(resp => {
                let res = resp.data;
                res.forEach((i, index) => {
                    res[index].isLeaf = selectedOptions.length == 2;
                })
                targetOption.children = res;
                targetOption.loading = false;
                this.RgstPrvcListCommun = [...this.RgstPrvcListCommun];
            })
        },
        // 初始化省份城市列表
        async initProCity() {
            if (this.pageData.province && this.pageData.city && this.pageData.area) {
                let index = this.RgstPrvcList.findIndex(i => i.areaCode == this.pageData.province);
                const param = {
                    classify: '2',
                    areaCode: this.pageData.province
                }
                await getAreaList(param).then(res => {
                    this.RgstPrvcList[index].children = res.data;
                })
                let area_index = this.RgstPrvcList[index].children.findIndex(i => i.areaCode == this.pageData.city);
                const area_param = {
                    classify: '3',
                    areaCode: this.pageData.city
                }
                await getAreaList(area_param).then(res => {
                    this.RgstPrvcList[index].children = this.RgstPrvcList[index].children || [];
                    this.RgstPrvcList[index].children[area_index].children = res.data;
                })
            }
            this.provCity = [this.pageData.province, this.pageData.city, this.pageData.area];
        },
        // 初始化通讯省份城市列表
        async initProCityCommun() {
            if (this.pageData.communicationProvince && this.pageData.communicationCity && this.pageData.communicationArea) {
                let index = this.RgstPrvcListCommun.findIndex(i => i.areaCode == this.pageData.communicationProvince);
                const param = {
                    classify: '2',
                    areaCode: this.pageData.communicationProvince
                }
                await getAreaList(param).then(res => {
                    this.RgstPrvcListCommun[index].children = res.data;
                })

                let area_index = this.RgstPrvcListCommun[index].children.findIndex(i => i.areaCode == this.pageData.communicationCity);
                const area_param = {
                    classify: '3',
                    areaCode: this.pageData.communicationCity
                };
                await getAreaList(area_param).then(res => {
                    this.RgstPrvcListCommun[index].children = this.RgstPrvcListCommun[index].children || [];
                    this.RgstPrvcListCommun[index].children[area_index].children = res.data;
                })
            }
            this.provcommunicationCity = [this.pageData.communicationProvince, this.pageData.communicationCity, this.pageData.communicationArea];
        },
        getUserChangeApplyId() {
            getUserChangeApplyId().then(res => {
                this.applyId = res.data.aplyId;
            })
        },
        uploadOk(data, fileParams) {
            const saveParams = {
                mdlId: 'approve',
                tblBlId: this.aprvInfo.aprvId,
                suprFileId: fileParams.suprFileId,
                fileTpCd: undefined,
                id: data[0] && data[0].id,
                fileExpdNm: data[0] && data[0].fileExpdNm,
                fileNm: data[0] && data[0].name,
                fileRte: data[0] && data[0].fileRte,
                fileSize: data[0] && data[0].size
            };

            let idItem = this.fileList.find(i => i.suprFileId == fileParams.suprFileId);
            if (idItem) {
                saveParams['id'] = idItem.id;
            }

            RcvbSingleFileSave(saveParams).then(res => {
                this.$message.success("上传成功");
                fileQueryAPI({
                    mdlId: 'approve',
                    tblBlId: this.aprvInfo.aprvId,
                    suprFileId: fileParams.suprFileId,
                })
                    .then(resp => {
                        let fileIds = this.fileList.map(i => Number(i.suprFileId));
                        let index = fileIds.indexOf(Number(fileParams.suprFileId));
                        if (index > -1) {
                            this.$set(this.fileList, index, {
                                ...saveParams,
                                fileId: data[0] && data[0].uid,
                                id: resp.data[0] && resp.data[0].id
                            })
                        } else {
                            this.fileList.push({
                                ...saveParams,
                                fileId: data[0] && data[0].uid,
                                id: resp.data[0] && resp.data[0].id
                            });
                        }
                    });
            }).catch(err => {
                console.log(err);
            })
        },
        removeOk(file) {
            this.fileList.forEach((i, index) => {
                if (i.fileId == file.uid) {
                    this.$set(this.fileList[index], "delet", true);
                }
            })
        },
        // 授权委托书模板下载
        fileDownload() {
            // window.open(this.SECURITY_FILE_DOWNLOAD_URI1, '_blank');
            this.utils.queryTemplateFile(this.SECURITY_FILE_DOWNLOAD_URI1)
        },
        // 下载税控安全认证工具
        safeDownload() {
            if (this.safeDownloadUrl) {
                window.open(this.safeDownloadUrl, '_self');
            } else {
                this.$message.error("获取税控安全认证工具失败");
            }
        },
        // 获取图片路径
        getFileRte(fileId) {
            if (!this.fileList[fileId]) {
                return '';
            }
            return `${this.DOWNLOAD_PREFIX}${this.fileList[fileId].fileRte}/${this.fileList[fileId].fileNm
                }`;
        },
        // 生成提交参数
        getParams() {
            // 营业期限
            const startEndDate1 = this.$refs.startEndDate1.getVal();
            this.pageData.businessHoursSd = startEndDate1.startValue;
            this.pageData.businessHoursEd = startEndDate1.endValue;
            // 法人有效期限
            const startEndDate2 = this.$refs.startEndDate2.getVal();
            this.pageData.legalPersonCertificateSd = startEndDate2.startValue;
            this.pageData.legalPersonCertificateEd = startEndDate2.endValue;
            // 管理员有效期限
            const startEndDate3 = this.$refs.startEndDate3.getVal();
            this.pageData.operatorIdNumberSd = startEndDate3.startValue;
            this.pageData.operatorIdNumberEd = startEndDate3.endValue;


            const {
                cstNm,
                orgCode,
                ctcPsnTel,
                phone,
                industryType,
                companyScale,
                address,
                country,
                province,
                city,
                lglpsnNm,
                legalPersonCertificateType,
                lglpsnCrdtNo,
                basicAccNo,
                basicAccName,
                mnpltPsnNm,
                mnpltPsnCrdtNo,
                // txnPswd,
                // confirmPswd,
                id,
                companyCategory,
                communicationProvince,
                communicationCity,
                communicationArea,
                communicationAddress,
                area,
                businessHoursSd,
                businessHoursEd,
                legalPersonCertificateSd,
                legalPersonCertificateEd,
                operatorIdNumberSd,
                operatorIdNumberEd,
                largeBankNo

            } = this.pageData;

            // const txnPswdEncrypt = this.utils.getPasswordEncryptString(txnPswd);
            // const confirmPswdEncrypt = this.utils.getPasswordEncryptString(confirmPswd);


            const params = {
                id,
                cstNm,
                orgCode,
                ctcPsnTel,
                phone,
                industryType,
                companyScale,
                address,
                country,
                province,
                city,
                lglpsnNm,
                legalPersonCertificateType,
                lglpsnCrdtNo,
                basicAccNo,
                basicAccName,
                mnpltPsnNm,
                mnpltPsnCrdtNo,
                // txnPswd: txnPswdEncrypt,
                // confirmPswd: confirmPswdEncrypt,
                companyCategory,
                communicationProvince,
                communicationCity,
                communicationAreaStr: communicationArea,
                communicationAddress,
                area,
                businessHoursSd,
                businessHoursEd: businessHoursEd || '长期',
                legalPersonCertificateSd,
                legalPersonCertificateEd: legalPersonCertificateEd || '长期',
                operatorIdNumberSd,
                operatorIdNumberEd: operatorIdNumberEd || '长期',
                largeBankNo
            };
            return params;
        },

        save() {
            this.$refs.vertifyForm.validate((valid) => {
                if (valid) {
                    if (this.fileList.length < 8) {
                        this.$message.error("请将必填文件上传完整");
                        return;
                    }
                    const params = this.getParams();
                    temporary(params).then(res => {
                        this.$message.success("保存成功！");
                    })
                } else {
                    this.$message.error("请将必填项填写完整");
                    return false;
                }
            });

        },
        submit() {
            if (this.fileList.length < 8) {
                this.$message.error("请将表单文件上传完整");
                return;
            }
            this.$refs.vertifyForm.validate((valid) => {
                if (valid) {
                    const params = this.getParams();
                    save(params).then(res => {
                        this.$message.success("已提交认证，请耐心等待结果！");
                        this.getUserInfo();
                    })
                } else {
                    this.$message.error("请将必填项填写完整");
                    return false;
                }
            });

        },
        openExample() {
            this.$refs.imgViewAprov.show();
        },
        goback() {
            this.MENUAPI.goToOneTab({
                path: 'security/vertify-management'
            });
        },
        //获取审批记录
        getUserInfoApprove() {
            getUserInfoApproveList(null, true).then(res => {
                this.dataList = res.data
            })
        }
    },
    created() {
        this.getUserChangeApplyId();
        this.getDicAsync("IdyTpCd").then(res => {
            this.industryList = res;
        })
        this.getDicAsync("LegalPersonCertType").then(res => {
            this.LegalPersonCertTypeList = res;
        })
        this.getDicAsync("EntpSz").then(res => {
            this.EntpSzList = res;
        })
        // this.getDicAsync("RgstCty").then(res => {
        //     this.RgstCtyList = res;
        // })
        getAreaList({
            classify: '1',
        }).then(resp => {
            let res = resp.data;
            res.forEach((i, index) => {
                res[index].isLeaf = false;
            })
            this.RgstPrvcList = this.utils.deepClone(res);
            this.RgstPrvcListCommun = this.utils.deepClone(res);
        })
        this.getDicAsync("CompanyCategoryStCd").then(res => {
            this.companyCategoryList = res;
        })

        this.getUserInfo();
        this.getUserInfoApprove()
    },
    mounted() { },
    watch: {},
}
</script>
<style scoped>
.ver-li {
    line-height: 30px;
    padding-left: 0;
}

.apro-box {
    border: 1px solid #ddd;
    padding: 15px;
}

.hoverText {
    position: absolute;
    z-index: 100;
    opacity: 0;
    left: -70px;
    cursor: pointer;
}

.input-text {
    color: #999;
    position: absolute;
    right: -38px;
    top: 40px;
}

.check-address {
    position: absolute;
    right: -120px;
    top: -4px;
}

.page-main {
    padding-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/security/vertify/vertify.vue